<template>
  <div class="card">
    <loading
      :active="isLoadingModel"
      :can-cancel="true"
      color=var(--primary-color)
      :is-full-page="fullPage"
    ></loading>
    <!-- {{Applicationsurvey}} -->
    <div class="m-0" style="text-align: center" v-if="Applicationsurvey">
    
      <!-- {{ ApplicationDetails }} -->
    </div>
    <div class="m-0" style="text-align: right">
                <Button label="Go Back"  icon="pi pi-angle-double-left" @click="goBack()" style="background-color: red; border-color: red;"/>
            </div>
    <Divider />
    <b>Application Details :</b>
    
    <!-- <table style="width:100%;" border="0" v-if="Applicationsurvey">
       <tbody>
        <tr v-for="(item, index) in Applicationsurvey" :key="index">
          <template v-for="(value, key) in item" :key="key">
            <tr>
              <td width="20">{{ key }}</td>
              <td>:</td>
              <td>{{ value }}</td>
            </tr>
          </template>
        </tr>
      </tbody> 
    </table> -->
    <ApplicationForm />

    <!-- <Divider />
    <b>Application Documents :</b>
    <div class="m-0" style="text-align: center"  v-if="App_LogHistory.length>0">
      <DataTable
        style="text-align: center"
        :value="App_LogHistory"
        size="small"
        paginator :rows="5" :rowsPerPageOptions="[5, 10, 20, 50]"
      >
        <Column field="Document_Name" header="Document Type"></Column>
        <Column field="Details" header="Details"></Column>
        <Column field="Link" header="Link"></Column>


      </DataTable>
    </div> -->
<Divider />

<DocumentDetails />
  
    <Divider v-if="App_LogHistory.length>0"/>
    <b v-if="App_LogHistory.length>0">Application Log History :</b>
    <div class="m-0" style="text-align: center" v-if="App_LogHistory.length>0">
      <DataTable
        style="text-align: center"
        :value="App_LogHistory"
        size="small"
       
      >
     
      <Column field="statusName" header="Application Status"></Column>
      <Column field="rejectRemarks" header="Remarks"></Column>
      <Column field="rejectReasonID" header="Rejection Reason"></Column>
      <Column field="createdDate" header="Approve/Reject Date"></Column>
      <Column field="approvedBy" header="Approver Name"></Column>
      </DataTable>
    </div>
    <Divider />
    <b>Application Approval :</b>
    <br><br>
      <div class="p-fluid formgrid grid">
        
                <div class="field col-12 md:col-3" >
                  <span class="p-float-label">
                 
                  <Dropdown 
                    id="status"
                    value-field="StatusID"
                    v-model="Approve_selectstatus"
                    :options="Approve_dropdownItems"
                    :value="Approve_dropdownItems.statusID"
                    optionLabel="status"
                    @change.native="checkReject"
                    required="true"
                  ></Dropdown>
                  <label for="status">Approve Application</label>
                </span>
                </div>
             
                <div class="field col-12 md:col-3" v-if="this.show">
                  <span class="p-float-label" >
                
                  <Dropdown
                    id="status"
                    v-model="Reject_selectstatus"
                    :options="Reject_dropdownItems"
                    :value="Reject_dropdownItems.rejectionReasonId"
                    optionLabel="rejectionReason"
                  
                    required="true"
                   
                  ></Dropdown>
                  <label for="status">Reject Reason</label>
                </span>
                </div>
                
               
                
        </div>
        <br>
        <div class="p-fluid formgrid grid">
          <div class="field col-12 md:col-3" v-if="this.display">
            <span class="p-float-label" >
                  <InputText
                  id="ApproveAmount"
                  :disabled="Approve_dropdownItems.length==0"
                  v-model="ApproveAmount"
                  required="true"
                  autofocus
                />
                <label for="amt">Approved Amount</label>
              </span>
                </div>
        </div>
        <br>
        <div class="p-fluid formgrid grid">
          <div class="field col-12 md:col-10">
              <span class="p-float-label">
                <Textarea
                  inputId="textarea"
                  rows="4"
                  cols="30"
                  v-model="product.remark"
                ></Textarea>

                <label for="topic">Remark</label>
              </span>
            </div>
        </div>
  
    <Divider />
    <div class="m-0" style="text-align: center">
      <Button label="Primary" class="p-button-success p-button-Raised mr-2 mb-2" @click="Application_Approval">Submit</Button>
      <Button label="Primary" class="p-button-danger p-button-Raised mr-2 mb-2" @click="cancel">Back</Button>
    </div>
    <!-- {{ApplicationDetails }}
    ---------------------------------------------------------
    {{Applicationsurvey }} -->
  </div>
</template>
<script>
import apis from "@/apis";
import axios from "axios";
import ApplicationForm from "../components/ApplicationForm.vue"
import InputText from "primevue/inputtext";
import DocumentDetails from "../components/DocumentDetails.vue";
//import DocumentDetails from "../components/DocumentDetails.vue";
export default {
  components:{
    ApplicationForm,
    DocumentDetails,
  },
  name: "EdukattaGovermentAdminUIApplicationApproval",
  data() {
    return {
      isLoadingModel:false,
      fullPage: true,
      ApplicationDetails: "",
      Applicationsurvey: [],
      App_LogHistory: [],
      App_ReadRejectReason: [],
      App_RoleStatusMappingByAppStatus: [],
      product:{},
      Reject_selectstatus:null,
      Reject_dropdownItems:[],
      Approve_selectstatus:null,
      Approve_dropdownItems:[],
      show:false,
      role_id: null,
      display: false,
      ApproveAmount: 0.00,
      file:'',

    };
  },
  async mounted() {
    if (localStorage.getItem("applicationdata")) 
    {
      this.ApplicationDetails = await JSON.parse(localStorage.getItem("applicationdata"));
      
      this.ApproveAmount = this.ApplicationDetails.approveAmount ? parseFloat(this.ApplicationDetails.approveAmount) : 0.00;
      if (localStorage.getItem("surveydata")) 
      {
        var temp=[];
        var survey=JSON.parse(localStorage.getItem("surveydata"));
        temp.push(JSON.parse(survey));
        this.Applicationsurvey =temp;

        console.log("survedata",this.Applicationsurvey);
      }

      

      // var jsonArray = Object.keys(this.Applicationsurvey).map(key => ({ key, value: this.Applicationsurvey[key] }));
      // console.log(jsonArray);
      localStorage.setItem("applicationdata", "");
      localStorage.setItem("surveydata", "");
    } else {
      this.$toast.add({
        severity: "error",
        summary: "Error!!!",
        detail: "Data Not Found",
        life: 3000,
      });

      this.$router.push({ name: "ApplicationList" });
      return false;
    }
    await this.Get_ApplicationLogHistory();
    await this.Get_ReadRejectReason();
    await this.Get_RoleStatusMappingByAppStatus();

    if (localStorage.getItem("user_role_id")) {
      this.role_id = parseInt(localStorage.getItem("user_role_id"));
      this.display = this.role_id === 8; 

    }

    
  

  },
  methods: {
      checkReject(evt) {
      console.log(this.Approve_selectstatus);
     if (this.Approve_selectstatus.isReject == 1) 
     {
        this.show = true;
     }else{
      this.show = false;
     }
    },
    ViewDOC(path)
        {       this.file = path;
                //window.open(path);
        },
    formatApplicationData(applicationData) {
      // Convert application_details back to JSON object
      const details = JSON.parse(applicationData.application_details);

      // Format application_details object
      const formattedDetails = JSON.stringify(details, null, 2);

      // Create a new object without application_details
      const newData = { ...applicationData };
      delete newData.application_details;

      // Combine formatted application_details with the rest of the data
      const formattedData = {
        ...newData,
        application_details: formattedDetails
      };

      // Convert the combined object to a formatted JSON string
      const formattedString = JSON.stringify(formattedData, null, 2);

      return formattedString;
    },
    cancel()
    {
      this.$router.push({ name: "ApplicationList" });
    },
    goBack() { 
      this.$router.go(-1);
    },
    //LOG
    async Application_Approval() {
      var application_id = this.ApplicationDetails["application_id"];
      var application_status = this.Approve_selectstatus.statusID;
      var RejectReason ="";
      if (this.Reject_selectstatus || this.Reject_selectstatus!=undefined || this.Reject_selectstatus!= null) {
        RejectReason = this.Reject_selectstatus.rejectionReasonId;
      }
      var RejectionRemarks = "";
      if (this.product.remark) {
         RejectionRemarks = this.product.remark;
      }
      
     
      var CreatedUser = localStorage.getItem("id");
      var data = {
        application_id: application_id,
        "application_id":application_id,
        "application_status":application_status.toString(),
        "RejectReason":RejectReason.toString(),
        "RejectionRemarks":RejectionRemarks,
        "ApproveAmount":this.ApproveAmount || 0.00,
        "CreatedUser":localStorage.getItem("id")
      };
      console.log("data1",data);
       this.isLoadingModel = true;
       var promise = apis.ApplicationApproval(data);
       promise.then((response) => {
         this.isLoadingModel = false;
         if (response.data.status==true) {
           this.$swal(response.data.message);
           this.$router.go(-1);
         } else {
           this.$swal(response.data.message);
         }
       });
    },
    //LOG
    D_M_Y_formatDate(date_parm) {
            if (date_parm) {
                let date = new Date(date_parm);
                let dd = date.getDate();
                let mm = date.getMonth() + 1;
                let yyyy = date.getFullYear();
                let new_date = dd + '-' + mm + '-' + yyyy;
                // alert(dd)
                if (dd.toString() != 'NaN') {
                    //this.receipt_new_date = new_date;
                    return new_date;
                } else {
                    return date_parm;
                }
            }
        },
    async Get_ApplicationLogHistory() {
      var application_id = this.ApplicationDetails["application_id"];
      var data = {
        application_id: application_id,
      };
      this.loading = true;
      var promise = apis.ApplicationLogHistory(data);
      promise.then((response) => {
        this.loading = false;
        for (let index = 0; index < response.data.data.length; index++) {
          response.data.data[index]['createdDate']=this.D_M_Y_formatDate(response.data.data[index]['createdDate']);
        }
        this.App_LogHistory = response.data.data;
      });
    },
    //REJECT REASON
    async Get_ReadRejectReason() {
      var data = {};
      this.loading = true;
      var promise = apis.ReadRejectReason(data);
      promise.then((response) => {
        this.loading = false;
        this.Reject_dropdownItems = response.data.data;
      });
    },
    //GET STATUS
    async Get_RoleStatusMappingByAppStatus() {
      var data = {
        RoleID: localStorage.getItem("user_role_id"),
        ApplicationStatus: this.ApplicationDetails.application_status,
      };
      this.loading = true;
      var promise = apis.RoleStatusMappingByAppStatus(data);
      promise.then((response) => {
        this.loading = false;
        this.Approve_dropdownItems = response.data.data;
      });
    },
  },
};
</script>